import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BRAND_CODES } from 'brand-config';
import { IBrand, BrandSliceType, BrandCompanyDetailsType } from './types';

const initialState: BrandSliceType = {
  id: '',
  domain: '',
  code: BRAND_CODES.privacyShield,
  name: '',
  faviconUrl: '',
  logoUrl: '',
  touchIconUrl: '',
  customerServicePhone: '',
  customerServiceEmail: '',
  noReplayEmail: '',
  registeredTrademark: false,
  createdAt: '',
  updatedAt: '',
  companyDetails: {
    altCustomerServiceEmail: '',
    altCustomerServiceNumber: '',
    brandCode: '',
    brokerIds: [],
    category: '',
    city: '',
    coBranded: false,
    code: '',
    companyEffectiveDate: '',
    companyTerminationDate: '',
    customMessage: '',
    customMessageEndDateTime: '',
    customMessageStartDateTime: '',
    country: '',
    createdAt: '',
    customData: '',
    customerCareNumber: '',
    customizations: [],
    description: '',
    enrollmentMethod: '',
    faqs: [],
    id: '',
    name: '',
    orderedBy: '',
    preEnrollment: false,
    state: '',
    street1: '',
    street2: '',
    taxExempt: false,
    type: '',
    updatedAt: '',
    zip: '',
  },
};

const brandSlice = createSlice({
  name: 'brand',
  initialState,
  reducers: {
    setBrand: (state, action: PayloadAction<IBrand>) => {
      return { ...state, ...action.payload };
    },
    setCompanyDetails: (
      state,
      action: PayloadAction<BrandCompanyDetailsType>,
    ) => {
      state.companyDetails = action.payload;
    },
    resetCompanyDetails: (state) => {
      state.companyDetails = initialState.companyDetails;
    },
  },
});

export const { setBrand, setCompanyDetails, resetCompanyDetails } =
  brandSlice.actions;

export default brandSlice.reducer;
